import React from 'react';

const Pay = () => {
    return (
        <div className='mt-5'>
            <h1 className='display-6'>Payment System Comming Soon...</h1>
        </div>
    );
};

export default Pay;